import MarketStateDailySnapshotWithComparisonOutput
	from '@app/model/market_state/output/MarketStateDailySnapshotWithComparisonOutput';
import CalendarDay from '@app/state/calendar/CalendarDay';

export default class MarketStateDailySnapshotState {
	marketStateDailySnapshot: MarketStateDailySnapshotWithComparisonOutput | undefined;
	calendarDay: CalendarDay
	isUpdating: boolean = false;
	updateFinished: boolean

	constructor(calendarDay: CalendarDay, marketStateDailySnapshot: MarketStateDailySnapshotWithComparisonOutput | undefined) {
		this.marketStateDailySnapshot = !!marketStateDailySnapshot ? new MarketStateDailySnapshotWithComparisonOutput(marketStateDailySnapshot):undefined;
		this.calendarDay = calendarDay;
	}

	public needsRefreshResults() {
		return !this.marketStateDailySnapshot || ! this.marketStateDailySnapshot.current || this.marketStateDailySnapshot.needsRefreshResults()
	}
}